import { useEffect, useState, createContext, useContext } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import { STUDENT_ROLE } from '@constants/roleconstants';
import { Button } from '@components/shares';
import DatePicker from 'antd/es/date-picker';
import Select from 'antd/es/select';
import './layout.css';
import { Bell } from 'lucide-react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { UserProfile } from '@components/shares';
import Menu, { MenuProps } from 'antd/es/menu';
import logo from '@assets/images/logo.png';
import { useWindowSize } from 'usehooks-ts';
import LanguageSelector from '@components/shares/LanguageSelector';
import { useStudentDashboard } from '@hooks/useStudentDashboard';
import blankAvatar from '@assets/images/blankavt.jpg';
import { studentMenu } from '@constants/ menuconstants';
import axios from 'axios';
import Live2DLipSync from '@features/student/practice/Live2DLipSync';
import Sidebar from '@components/Menu';
import LoadingH5pEvent3D from '@components/shares/H5pEvent3D';
import { useStudentPractice } from '@hooks/useStudentPractice';
import { useCommon } from '@hooks/useCommon';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import AIConversation from '@components/shares/AIConversation';
import { useDispatch } from 'react-redux';
import { setShowAIConversation } from '@store/reducers/commonReducer';
import { useSessionWatcher } from '@hooks/useSessionWatcher';
export const CalendarContext = createContext({
  selectedDate: new Date(),
  setSelectedDate: (date: Date) => {},
  calendarView: 'week',
  setCalendarView: (view: string) => {},
});
export const useCalendarContextStudent = () => useContext(CalendarContext);

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const SideBar = () => {
  const { width = 0, height = 0 } = useWindowSize();
  const [current, setCurrent] = useState(
    sessionStorage.getItem('selectedKey') || 'dashboard',
  );
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();
  const onClick: MenuProps['onClick'] = (e) => {
    sessionStorage.setItem('selectedKey', e.key);
    setCurrent(e.key);
  };
  const isSmallScreenSize = width < 1000;
  const handleChangeCollapseMenu = () => {
    setCollapsed(!collapsed);
  };
  return (
    <aside className={`h-[100vh] fixed bottom-0 left-0 w-[260px] z-[31]`}>
      <nav className='min-h-full flex flex-col bg-white border-r relative'>
        <div className='p-4 pb-5 flex justify-center'>
          <img
            src={logo}
            className={`overflow-hidden transition-all ${collapsed || isSmallScreenSize ? 'w-0' : 'w-100'}`}
          />
        </div>
        <Sidebar />
        {/* <Menu onClick={onClick} selectedKeys={[current]} mode="inline" items={studentMenu} inlineCollapsed={collapsed || isSmallScreenSize} /> */}
        {/* <button className={`bg-primary border-none absolute bottom-5 py-1 pl-2 pr-1 ${collapsed || isSmallScreenSize ? 'right-0 rounded-l-sm' : 'right-[-28px] rounded-r-sm'}`} onClick={() => handleChangeCollapseMenu()}>
                    {
                        collapsed || isSmallScreenSize ? <MenuFoldOutlined className="text-white " /> :
                            <MenuUnfoldOutlined className="text-white" />
                    }
                </button> */}
        <div
          className={`flex ${collapsed || isSmallScreenSize ? 'w-[50px]' : 'w-52 ml-5'}`}
        ></div>
      </nav>
    </aside>
  );
};

interface LayoutStudentProps {
  offAiAssistant: boolean | false;
  replaceButton?: boolean | false;
  useModuleFilter?: boolean | false;
  useTimeFilter?: boolean | true;
}

export const LayoutStudent: React.FC<LayoutStudentProps> = ({
  offAiAssistant,
  replaceButton,
  useModuleFilter,
  useTimeFilter,
}) => {
  const location = useLocation();
  const isCalendarPage = location.pathname.includes('/calendar');
  // Calendar context state
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState('week');
  const [isOpenUserProfile, setIsShowUserProfile] = useState(false);
  const { t } = useTranslation();
  const handleClickUserProfile = () => {
    setIsShowUserProfile(!isOpenUserProfile);
  };
  const { filterData, setFilterDataAction } = useStudentDashboard();
  const { fetchStudentClassModuleAction, studentClassModuleList, loading } =
    useStudentPractice();
  const { userDetail, fetchUserDetailAction } = useCommon();

  const transformedClassListData =
    userDetail?.classes?.map((c: any) => ({
      label: c.class_name,
      value: c.id,
    })) || [];

  // Get unique modules from all classes
  const uniqueModules =
    userDetail?.classes?.reduce((acc: any[], curr: any) => {
      curr.module_ids?.forEach((module: any) => {
        if (!acc.find((m: any) => m.module_id === module.module_id)) {
          acc.push(module);
        }
      });
      return acc;
    }, []) || [];

  const moduleOptions = studentClassModuleList.map((module: any) => ({
    label: module.name,
    value: module.id,
  }));

  const { RangePicker } = DatePicker;
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { height = 0 } = useWindowSize();
  const [audioUrl, setAudioUrl] = useState('');
  const dispatch = useDispatch();

  useSessionWatcher();
  const [listClass, setListClass] = useState<
    {
      class_id: number;
      class_name: string;
      name: string;
      status: number;
      module_id: number;
    }[]
  >([]);

  // Function to format a date as dd/mm/yyyy
  function formatDate(date: Date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Get today's date
  const today = dayjs(new Date());

  // Get a date one month ago
  const oneMonthAgo = dayjs(new Date()).subtract(1, 'month');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const moduleParam = params.get('module');
    const classParam = params.get('class');

    if (moduleParam && classParam) {
      const selectedModules = studentClassModuleList.filter(
        (m: { id: number }) => m.id === parseInt(moduleParam),
      );
      const newListClass = selectedModules.map(
        (m: {
          class_id: any;
          class_name: any;
          name: string;
          status: number;
          id: number;
        }) => ({
          class_id: m?.class_id,
          class_name: m?.class_name,
          name: m?.name || 'Unknown',
          status: m?.status,
          module_id: m?.id,
        }),
      );
      const selectedClass = newListClass.find(
        (cls: { class_id: number }) => cls.class_id === parseInt(classParam),
      );
      if (selectedClass) {
        setFilterDataAction({
          ...filterData,
          id: selectedClass.module_id,
          class_id: selectedClass.class_id,
          class_name: selectedClass.class_name,
          name: selectedClass.name,
          status: selectedClass.status,
        });
      } else {
        setFilterDataAction({
          ...filterData,
          id: parseInt(moduleParam),
          class_id: parseInt(classParam),
        });
      }
      setListClass(newListClass);
    } else {
      if (!filterData?.id && studentClassModuleList?.length > 0) {
        setFilterDataAction({
          ...filterData,
          id: studentClassModuleList[0]?.id,
          name: studentClassModuleList[0]?.name,
          status: studentClassModuleList[0]?.status,
          class_id: studentClassModuleList[0]?.class_id,
          class_name: studentClassModuleList[0]?.class_name || 'Unknown',
        });
      }
      const initialClassList = studentClassModuleList.filter(
        (m: { id: any }) => m.id === studentClassModuleList[0]?.id,
      );
      const newListClass = initialClassList.map(
        (m: {
          class_id: any;
          class_name: any;
          name: any;
          status: any;
          id: number;
        }) => ({
          class_id: m.class_id,
          class_name: m.class_name,
          name: m.name || 'Unknown',
          status: m.status,
          module_id: m?.id,
        }),
      );
      setListClass(newListClass);
    }
  }, [studentClassModuleList, location.search]);

  useEffect(() => {
    if (location.pathname === '/student') {
      navigate('/student/dashboard');
    }
  }, [location.pathname]);
  const isReportScreen = location.pathname.includes('/report');
  const isProfileScreen = location.pathname.startsWith('/student/profile');
  const hideHeaderTools = Boolean(replaceButton) || isProfileScreen;
  useEffect(() => {
    if (isReportScreen) {
      fetchStudentClassModuleAction();
    }
  }, [isReportScreen]);

  useEffect(() => {
    if (!auth.access_token || auth.role !== STUDENT_ROLE) {
      navigate('/user/login');
    }
  }, [auth.access_token, navigate]);

  const handleChangeRangePicker = (
    dates: any,
    dateStrings: [string, string],
  ) => {
    if (dateStrings?.length === 2) {
      setFilterDataAction({
        ...filterData,
        start_date: dateStrings[0],
        end_date: dateStrings[1],
      });
    }
  };

  useEffect(() => {
    if (listClass?.length > 0 && filterData?.id !== listClass[0]?.module_id) {
      setFilterDataAction({
        ...filterData,
        id: listClass[0]?.module_id,
        class_id: listClass[0]?.class_id,
        class_name: listClass[0]?.class_name,
        name: listClass[0]?.name,
        status: listClass[0]?.status,
      });
    }
  }, [listClass]);

  const handleChangeModule = (value: number) => {
    setFilterDataAction({
      ...filterData,
      id: value,
    });
  };

  const handleChangeClass = (value: number) => {
    const selectedClass = transformedClassListData.find(
      (cls: any) => cls.class_id === value,
    );
    setFilterDataAction({
      ...filterData,
      class_id: value,
      class_name: selectedClass?.class_name,
      name: selectedClass?.name,
      status: selectedClass?.status,
    });
  };
  const listClassOptions =
    listClass?.length > 0 &&
    listClass?.map((m: { class_id: number; class_name: string }) => ({
      label: m?.class_name,
      value: m?.class_id,
    }));

  const answerChat = async (text: string): Promise<string> => {
    try {
      let response = await axios.get(
        `${REACT_APP_API_URL}/api/speech/synthesize`,
        {
          params: { prompt: text },
        },
      );

      console.log('Synthesize Response:', response.data.synthesized_text);
      if (response.data.synthesized_text) {
        response = await axios.get(`${REACT_APP_API_URL}/api/speech/tts`, {
          params: { text: response.data.synthesized_text },
        });

        console.log('TTS Response:', response.data.audio_url);
        if (response.data.audio_url) {
          setAudioUrl(response.data.audio_url);
        }
      }
    } catch (error) {
      console.error('Error fetching TTS:', error);
      throw error;
    }

    return 'Done';
  };

  const isCalendarScreen =
    typeof window !== undefined &&
    window.location.href.includes('/student/calendar');
  const isPracticeScreen =
    typeof window !== undefined &&
    window.location.href.includes('/student/practice');

  return (
    <CalendarContext.Provider
      value={{ selectedDate, setSelectedDate, calendarView, setCalendarView }}
    >
      <div className='flex h-screen'>
        <SideBar />
        <div className='w-full h-full ml-[250px] mt-[90px]'>
          <div
            className={`fixed top-0 right-0 w-full h-[90px] z-[30] pl-[250px] bg-white shadow-md flex flex-row ${isCalendarScreen || isPracticeScreen || hideHeaderTools || isReportScreen ? 'justify-end' : 'justify-between'} items-center`}
          >
            {!hideHeaderTools &&
              !isCalendarScreen &&
              !isPracticeScreen &&
              !isReportScreen && (
                <div className='flex items-center px-[30px]'>
                  {/* <div>
                                <div className='text-sm font-bold mb-1'>{t('class.class')}</div>
                                <Select
                                    className='h-[40px] mr-3'
                                    placeholder={t('class.class')}
                                    options={transformedClassListData}
                                    value={filterData?.class_id}
                                    disabled={!listClassOptions?.length}
                                    onChange={handleChangeClass}
                                />
                            </div> */}
                  {useTimeFilter !== false && (
                    <div>
                      <div className='text-sm font-bold mb-1'>
                        {t('common.time')}
                      </div>
                      <RangePicker
                        className='h-[40px] mr-3'
                        placeholder={[
                          t('common.from_date'),
                          t('common.to_date'),
                        ]}
                        defaultValue={[oneMonthAgo, today]}
                        onChange={handleChangeRangePicker}
                        id={{
                          start: 'from_date',
                          end: 'end-date-input',
                        }}
                        format={'DD/MM/YYYY'}
                      />
                    </div>
                  )}
                </div>
              )}
            <div className='flex flex-row items-center mr-20 h-[90px]'>
              {/* <div className='relative p-3 rounded-full hover:bg-success/10 hover:text-success cursor-pointer text-gray-500 mr-8'>
                            <Bell size={20} />
                            <span className='flex justify-center items-center bg-red w-5 h-5 rounded-full absolute top-0 left-[20px] text-white text-[12px]' >4</span>
                        </div> */}
              <div className='mr-12 '>
                <LanguageSelector />
              </div>
              <UserProfile
                imageUrl={auth?.avatar_url ?? blankAvatar}
                avatarSize='md'
                userName={auth?.full_name}
                userRole='Học sinh'
              />
            </div>
          </div>
          <div
            className={`px-[30px] py-[40px] w-full ${isCalendarPage ? 'no-scroll' : 'overflow-auto'} bg-[#F6F7F9]`}
            style={{ height: `${height - 70}px` }}
          >
            <div id='h5p-container '></div>
            <Outlet />
          </div>
        </div>
        <AIConversation />
      </div>
    </CalendarContext.Provider>
  );
};
